import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/$eventUuid"
)({
  component: function EventLayout() {
    return <Outlet />
  },
})
